import { StateVariant } from "@tagged-state/core";
import { createContext } from "@tagged-state/react";

export type State =
  | StateVariant<"uninit">
  | StateVariant<"pending">
  | StateVariant<"ready">
  | StateVariant<"error", { error: Error }>;

const { Context, ComponentGuard } = createContext<State>({
  tag: "uninit",
  data: {},
});

export const Web3OnboardContext = Context;
export const Web3OnboardGuard = ComponentGuard;
